export default __webpack_public_path__ + "assets/c323c3dfd6b8288a0eb1b40e26c946fd.jpg";